import * as types from '../actions/actionTypes';
import {SummaryDTO} from '../types/SummaryDTO'
 
  export interface WeeklySummaryState {
    summaries: SummaryDTO[];
    error: string | null;
  }
  

  export interface LoadWeeklySummariesSuccessAction {
  type: typeof types.LOAD_WEEKLY_SUMMARIES_SUCCESS;
  payload: SummaryDTO[];
}

interface LoadWeeklySummariesErrorAction {
  type: typeof types.LOAD_WEEKLY_SUMMARIES_ERROR;
  payload: string;
}


type WeeklySummaryAction =
  | LoadWeeklySummariesSuccessAction
  | LoadWeeklySummariesErrorAction;

  /* ================= STATE ================= */
  

export interface WeeklySummaryState {
  summaries: SummaryDTO[];
  error: string | null;
}

  export const initialState: WeeklySummaryState = {
    summaries: [],
    error: null,
  };


/* ================= REDUCER ================= */
  
const weeklySummaryReducer = (
  state: WeeklySummaryState = initialState,
  action: WeeklySummaryAction
): WeeklySummaryState => {
    switch (action.type) {
      case types.LOAD_WEEKLY_SUMMARIES_SUCCESS:
        return {
          ...state,
          summaries: action.payload,
          error: null,
        };
      case types.LOAD_WEEKLY_SUMMARIES_ERROR:
        return {
          ...state,
          summaries: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default weeklySummaryReducer;
  